// VideoLightShot.tsx
import * as React from 'react';
import Lightbox, {
    type Slide,
    type YouTubeSlide,
} from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import { SetOpenCallbackFunction } from '../types/callback';
import { displayErrorToast } from '../utils/toasts';
import { cookies } from '../cookies';

declare module "yet-another-react-lightbox" {
    export interface YouTubeSlide extends GenericSlide {
        type: "youtube";
        video: string;
    }

    interface SlideTypes {
        "youtube": YouTubeSlide;
    }
}

function isYouTubeSlide(slide: Slide): slide is YouTubeSlide {
    return slide.type === "youtube";
}

function RenderYouTubeSlide({ slide }: { slide: YouTubeSlide }) {

    return (
        <iframe width="90%"
            height="90%"
            src={slide.video}
            title="OBOSS - YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen />
    )
}

export function VideoLightShot({ videos, opened, setOpenLightShot }: { videos: YouTubeSlide[] | undefined, opened: boolean, setOpenLightShot: SetOpenCallbackFunction }) {

    if(!navigator.canShare && cookies.get('webshare.error') === undefined) {
        cookies.set('webshare.error', 'true', { maxAge: 3600 });
        displayErrorToast("Note: your current browser does not support the Web Share API");
    }

    console.log(videos);

    return videos === undefined ? (
        <> </>
    ) : (
        <Lightbox
            open={opened}
            slides={[...videos]}
            render={{
                slide: ({ slide, offset, rect }) =>
                isYouTubeSlide(slide) ? (
                    <RenderYouTubeSlide slide={slide} />
                ) : null
            }}
            plugins={[Video, Thumbnails]}
            close={() => setOpenLightShot(false)} />
    )
}
